import { makeStyles, Text } from "@fluentui/react-components";
import CookieConsent from "react-cookie-consent";
import { dolphinTokens } from "../utils/Theme";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

const useStyles = makeStyles({
    container: {
        alignItems: "center !important",
        backgroundColor: `${dolphinTokens.colorDarkBlue} !important`
    },
    text: {
        margin: 0,

        "& a": {
            color: `white !important`,
            textDecoration: "underline !important"
        }
    },
    acceptButton: {
        backgroundColor: "white !important",
        color: `${dolphinTokens.colorDarkBlue} !important`,
        padding: "10px 20px !important",
        borderRadius: "5px !important",

        "@media (min-width: 436px)": {
            display: "block !important",
            margin: ".75rem auto 0 auto !important",
            transform: "translateX(-8px) !important",
        }
    },
    declineButton: {
        backgroundColor: `${dolphinTokens.colorTomatoRed80} !important`,
        color: "white !important",
        borderRadius: "5px !important",

        "@media (max-width: 435px)": {
            padding: "10px 20px !important",
        },

        "@media (min-width: 436px)": {
            display: "block !important",
            margin: ".5rem auto .75rem auto !important",
            transform: "translateX(-8px) !important",
        }
    }
});

export default function Consent() {
    const { t } = useTranslation("general");
    const styles = useStyles();

    return (
        <CookieConsent enableDeclineButton flipButtons
            location="bottom"
            buttonText="Accept"
            cookieName="user_cookie_consent"
            expires={150}
            containerClasses={styles.container}
            buttonClasses={styles.acceptButton}
            declineButtonClasses={styles.declineButton}
            declineButtonText="Essential Only"
            acceptOnScroll={false}
            >
            <Text block as="p" size={400} className={styles.text}>
                {t("cookies.text1")}
            </Text>
            <Text block as="p" size={400} className={styles.text}>
                {t("cookies.text2")}
            </Text>
            <Text block as="p" size={400} className={styles.text}>
                <Trans i18nKey="cookies.text3" components={{
                    1: <Link to="/legal/cookie-policy" target="_blank" />
                }}>
                </Trans>
            </Text>
        </CookieConsent>
    );
}